/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";
import { Text } from "../../../components/general/Text";
import { FlexContainer } from "../../../containers/FlexContainer";
import { GlobalStore } from "../../../store/global/GlobalStore";
import { WrapStatus } from "../../../types/wrapQuote";
import { WrapBackButton } from "./WrapBackButton";

export interface WrapHeaderProps {
  title: string;
  wrapStatus: string;
}

export const WrapHeader: React.FC<WrapHeaderProps> = ({ title, wrapStatus }) => {
  const theme = GlobalStore.useState(s => s.theme);
  return (
    <FlexContainer data-testid="wrap-header">
      {wrapStatus === WrapStatus.REVIEW && <WrapBackButton />}
      <Text
        textStyle={"Title"}
        size={"Medium"}
        color={theme.font.primary.default}
        as={"h5"}
        textCss={css`
          text-align: center;
          width: 100%;
        `}
      >
        {title}
      </Text>
    </FlexContainer>
  );
};
